export default "__VITE_ASSET__fe7554cc__"